import type { Component, Entity2D } from '../../odie';

import type { ThickIceBlockProps } from '../defs/block';
import { ThickIceBlockView } from '../views/blocks/ThickIceBlockView';

// types
//-----------------------------------------------------------------------------
export type ThickIceBlockComponentOptions = {
  props: ThickIceBlockProps;
};

/*
    thick ice block component
*/
export class ThickIceBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockThickIce';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: ThickIceBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: ThickIceBlockComponentOptions): void {
    // create thick ice block view
    this.view = new ThickIceBlockView(options.props);
  }
}
